import styled from 'styled-components'

import { colors } from '../../../module/colors'
import {
  text_lg,
  text_xxl,
  text_md,
  size_4,
  size_2,
  size_8,
  size_6,
  text_thin,
  centredFlex,
} from '../../../module/style-variables'

export const WorkoutCompletionContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const Title = styled.div`
  ${text_md};
  ${text_thin};
  color: ${colors.copy};
  padding: ${size_4} ${size_4} ${size_2} ${size_4};
`
export const SecondaryTitle = styled.div`
  ${text_lg};
  ${text_thin};
  color: ${colors.copy};
`

const counterSize = '120px'
export const CounterDisplay = styled.div`
  height: ${counterSize};
  width: ${counterSize};
  border-radius: ${counterSize};
  background-color: ${colors.secondary};
  color: white;
  margin: auto;
  margin-top: ${size_8};
  margin-bottom: ${size_8};
  ${centredFlex};
  ${text_xxl};
  ${text_thin};
`
export const ProgressDisplayContainer = styled.div`
  width: 100%;
  padding: 0 ${size_6} ${size_8} ${size_6};
`
export const ButtonContainer = styled.div`
  width: 100%;
  padding-top: ${size_6};
  padding-bottom: ${size_6};
`



// WEBPACK FOOTER //
// ./src/component/_presentational/WorkoutCompletion/WorkoutCompletion-styled.js